/* eslint-disable no-debugger */
/* eslint-disable no-shadow */
/* eslint-disable no-useless-escape */
/* eslint-disable react/no-children-prop */
/* eslint-disable import/extensions */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import Cookies from 'js-cookie';
import { ACTIVATE_REGISTRY_INVITE, GET_CURRENT_USER, GET_USER, VALIDATE_INVITE } from 'api';
import { NewPost } from 'core/NewPost';
import { Notification } from 'core/Notification';
import { PostsList } from 'core/PostsList';
import KycModalWrapper from '../../components/Modals/KycModal/KycModal';
import styles from './FeedPage.module.scss';
import { setOffNotificationSetting } from '../../api/user/endpoints/settings';
import { openNotification } from 'tt-ui-lib/core';
import { UpIcon } from 'tt-ui-lib/icons';
import { useSelectedContext } from 'context/contextSelector';
import DraftRegistrationModal from '../../components/Modals/DraftRegistrationModal';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { GoogleAuthModal } from '../../modules/tt-modals';
import { openAppLoader } from '../../utils/appUtils';
import CreateAccountModal from 'components/CreateAccountModal';

const FeedPage = ({ scrollDown, scrollToTop, logOut }) => {
  const [showNeedKYCModal, setShowNeedKYCModal] = useState(false);
  const [idUser, setIdUser] = useState(Cookies.get('userId'));
  const [kyc, setKyc] = useState();
  const [notificationOff, setNotificationOff] = useState(true);
  const [firstNotificationVision, setFirstNotificationVision] = useState(false);
  const [fetchPosts, setFetchPosts] = useState(true);
  const [isIndividual, setIsIndividual] = useState(true);
  const [getUser] = useLazyQuery(GET_USER);
  const [validateInvite] = useLazyQuery(VALIDATE_INVITE);
  const [acceptInvitation] = useMutation(ACTIVATE_REGISTRY_INVITE);
  const [searchParams, setSearchParams] = useSearchParams();
  const [getCurrentUser] = useLazyQuery(GET_CURRENT_USER);
  const [googleWelcomeModal, setGoogleWelcomeModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, changeUserData } = useSelectedContext((context) => context.user);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isCodeValidated, setIsCodeValidated] = useState(false);
  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  console.log('isCreateModalOpen', isCreateModalOpen, 'code', code);

  const setUserCookies = (accessToken, refreshToken, user, setId) => {
    const domainValue = process.env.REACT_APP_DOMAIN;
    Cookies.set('access_token', accessToken, { domain: domainValue });
    Cookies.set('refresh_token', refreshToken, { domain: domainValue });
    Cookies.set('userId', user.id, { domain: domainValue });
    Cookies.set('calculatorId', user.calculator_id, { domain: domainValue });
    setId(user.id);
  };

  useEffect(() => {
    if (!code) return;

    if (code && !isCodeValidated) {
      validateInvite({ variables: { input: { code } } })
        .then((response) => {
          if (response?.data?.validateInvitation?.status) {
            console.log(user);
            if (user?.id) logOut(false);
            setIsCreateModalOpen(true);
          } else {
            openNotification({
              message: 'Error',
              description: response?.data?.validateInvitation?.error || 'Invalid invitation code',
              type: 'error',
            });
            setIsCreateModalOpen(false);
          }
        })
        .catch((error) => {
          openNotification({
            message: 'Error',
            description: error.message || 'An error occurred while validating the invitation code',
            type: 'error',
          });
          setIsCreateModalOpen(false);
        })
        .finally(() => {
          setIsCodeValidated(true);
        });
    } else if (!code) {
      setIsCreateModalOpen(false);
    }
  }, [code, isCodeValidated, validateInvite, user]);

  const handleCreate = (values) => {
    acceptInvitation({
      variables: {
        input: {
          code,
          password: values.password,
          password_confirmation: values.confirmPassword,
        },
      },
    })
      .then((response) => {
        const { data, errors } = response;
        if (!errors && data.RegisterByRegistryInvitation.tokens.user.id) {
          const accessToken = data.RegisterByRegistryInvitation.tokens.access_token;
          const refreshToken = data.RegisterByRegistryInvitation.tokens.refresh_token;
          setUserCookies(
            accessToken,
            refreshToken,
            response.data.RegisterByRegistryInvitation.tokens.user,
            setIdUser
          );
          setIsCreateModalOpen(false);
          openNotification({
            message: 'Success',
            description: 'Account created successfully',
            type: 'success',
          });
          params.delete('code');
          navigate({ search: params.toString() });
          window.location.reload();
        } else {
          openNotification({
            message: 'Error',
            description:
              response?.data?.RegisterByRegistryInvitation?.error || 'Failed to create account',
            type: 'error',
          });
        }
      })
      .catch((error) => {
        openNotification({
          message: 'Error',
          description: error.message || 'An error occurred while creating the account',
          type: 'error',
        });
      })
      .finally(() => {
        setIsCreateModalOpen(false);
        params.delete('code');
        navigate({ search: params.toString() });
      });
  };

  const handleClose = () => {
    setIsCreateModalOpen(false);
  };

  useEffect(() => {
    if (!user?.id && !isCreateModalOpen && isCodeValidated) {
      params.delete('code');
      navigate({ search: params.toString() });
    }
  }, [isCreateModalOpen, user, isCodeValidated]);

  useEffect(() => {
    if (
      location &&
      location.state &&
      location.state.action &&
      location.state.action.isOpenNotification
    ) {
      location.state.action.openNotification();
      navigate(location.pathname, {});
    }
  }, [user, location]);

  const getUserValue = async () => {
    const userValue = await getUser({ variables: { id: idUser } });
    if (userValue?.data?.user) {
      changeUserData(userValue.data.user);
      setKyc(userValue.data.user.kyc);
      const notificationsOff =
        userValue.data.user.settings?.find((item) => item.name === 'off_notifications') || null;
      setNotificationOff(notificationsOff?.value === 'true' || false);
    }
  };

  const setUser = (accessToken, user) => {
    const domainValue = process.env.REACT_APP_DOMAIN;
    Cookies.set('userId', user.id, { httpOnly: false, domain: domainValue });
    Cookies.set('calculatorId', user.calculator_id, { domain: domainValue });
  };

  useEffect(() => {
    (async () => {
      const accessToken = searchParams.get('access_token');
      const refreshToken = searchParams.get('refresh_token');
      const googleAuthPending = searchParams.get('google_auth');
      if (accessToken) {
        openAppLoader();
        searchParams.delete('access_token');
        setSearchParams(searchParams);
        const domainValue = process.env.REACT_APP_DOMAIN;
        Cookies.set('access_token', accessToken, { domain: domainValue });
        Cookies.set('refresh_token', refreshToken, { domain: domainValue });
        const response = await getCurrentUser();
        if (response?.data?.currentUser && response?.data?.currentUser.id) {
          setUser(accessToken, response.data.currentUser);
          changeUserData(response.data.currentUser);
        }
      } else if (googleAuthPending === 'pending') {
        searchParams.delete('google_auth');
        setGoogleWelcomeModal(true);
        setSearchParams(searchParams);
      }
    })();
  }, []);

  const signInWithGoogle = () => {
    const url = `${process.env.REACT_APP_SSO}/login/google?registrationType=individual`;
    window.location.replace(url);
  };

  useEffect(() => {
    (async () => {
      if (idUser) {
        await getUserValue();
      }
    })();
  }, [idUser]);

  useEffect(() => {
    if (user.roles && user.roles.length) {
      const roleExpert = user.roles?.find((elem) => elem.name === 'expert');
      const roleBusiness = user.roles?.find((elem) => elem.name === 'business');
      const roleInvestor = user.roles?.find((elem) => elem.name === 'investor');
      if (roleExpert || roleBusiness || roleInvestor) {
        setIsIndividual(false);
      } else {
        const roleHolder = user.roles?.find((elem) => elem.name === 'holder');
        if (roleHolder) {
          setIsIndividual(false);
        } else {
          const roleIndividual = user.roles?.find((elem) => elem.name === 'individual');

          if (roleIndividual) {
            setIsIndividual(true);
          } else {
            setIsIndividual(false);
          }
        }
      }
    }
  }, [user]);

  const disableNotifications = () => {
    setOffNotificationSetting(true).catch(() => {
      openNotification({
        message: 'Error occurred while disabling notifications. Try again later.',
        type: 'error',
      });
    });
  };

  return (
    <>
      {/* TODO uncomment */}
      {/* {!user.id && ( */}
      {/*  <div className={styles.fixedTopElement}> */}
      {/*    <UnauthDashboardTooltip /> */}
      {/*  </div> */}
      {/* )} */}
      {user.id && (
        <div className={styles.fixedTopElement}>
          <div className={styles.newPost}>
            <NewPost user={user} onClose={() => setFetchPosts(true)} />
          </div>
        </div>
      )}
      <div className={styles.contentBox}>
        <div hidden={firstNotificationVision}>
          {!notificationOff &&
          ((kyc === null && !isIndividual) ||
            (kyc !== 'success' && kyc !== 'pending' && !isIndividual)) ? (
            <Notification
              type={1}
              openModal={() => setShowNeedKYCModal(true)}
              close={() => setFirstNotificationVision(true)}
              text="Please complete the KYC process to gain access to all tools and demonstrate your transparency
                    to all members.<br />
                    To pass through KYC successfully, make sure that your ID documents are ready."
              disableNotifications={disableNotifications}
            />
          ) : null}
        </div>
        {/* {!isIndividual && (
              <div hidden={secondNotificationVision}>
                <Notification
                  close={() => setSecondNotificationVision(true)}
                  text="To start operating on TransparenTerra, you must create your company(ies) account(s)."
                />
              </div>
            )} */}
        <div style={{ position: 'relative' }}>
          <PostsList isFetchPosts={fetchPosts} setIsFetchPosts={setFetchPosts} />

          {scrollDown && (
            <div onClick={scrollToTop} className={styles.upButton}>
              <UpIcon style={{ width: 19, height: 19 }} />
            </div>
          )}
        </div>

        <KycModalWrapper
          isOpen={showNeedKYCModal}
          setIsOpen={setShowNeedKYCModal}
          userId={user.id}
          userKyc={user?.kyc}
        />
        <DraftRegistrationModal />
        <GoogleAuthModal
          onClose={() => setGoogleWelcomeModal(false)}
          open={googleWelcomeModal}
          onSubmit={signInWithGoogle}
        />
        {code && isCodeValidated && (
          <CreateAccountModal
            open={isCreateModalOpen}
            onCancel={handleClose}
            onCreate={handleCreate}
          />
        )}
      </div>
    </>
  );
};

export default FeedPage;
